import React from 'react';
import has from 'lodash/has';
import PropTypes from 'prop-types';
import PeopleDetailsCard from '../../components/people/peopleDetails/people.details.card';
import PeopleDetailsGrid from '../../components/people/peopleDetails/people.details.grid.container';
import Notification from '../../components/common/notification/notification.component';
import Loading from '../../components/loading/loading.component';

class PeopleDetailsPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let userId = this.props.match.params.userId;
    let studyGid = this.props.match.params.studyGid;

    if (null == this.props.location.state) {
      this.props.fetchUser(userId);
      if (null != studyGid) {
        this.props.fetchStudy(studyGid);
      }
    }
  }

  render() {
    let user = null;
    //on people flow the study is not present or needed
    const study = this.props.study || {};

    if (this.props.error) {
      return <Notification type="error" data={this.props.error} />;
    }

    if (has(this.props.location.state, 'user')) {
      user = this.props.location.state.user;
    }

    if (this.props.isFetching || (null == this.props.user && null == user)) {
      return <Loading />;
    }

    /**
     * If state is null then means that the page is redirected by sso after login
     * This means that the breadcrumb state will be undefined so here in order to provide the values for
     * breadcrumb state, we use the history.push to redirect to same location adding the values to state
     */
    if (null == this.context.router.route.location.state) {
      this.context.router.history.push(this.context.router.route.location.pathname, {
        user: this.props.user,
        studyGid: study.gid,
        studyName: study.name,
        forBreadcrumb: { ...this.props.user, studyGid: study.gid, studyName: study.name }
      });
      return <span />;
    }

    return (
      <div id="people-details-page">
        <div id="people-details-page">
          <PeopleDetailsCard user={this.context.router.route.location.state.user} />
          <PeopleDetailsGrid user={this.context.router.route.location.state.user} />
        </div>
      </div>
    );
  }
}

PeopleDetailsPage.contextTypes = {
  router: PropTypes.object.isRequired
};

PeopleDetailsPage.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object,
  isFetching: PropTypes.bool,
  fetchUser: PropTypes.func,
  error: PropTypes.object
};

export default PeopleDetailsPage;
